import React, { useState, useEffect } from "react";
import { subscribeToEvent, sendRequest } from "../api";
import StatusChip from "./StatusChip";
import OverrideStatus from "./OverrideStatus";
import RiddleCard from "./RiddleCard";
import { Chip } from "react-materialize";

const MiscCard = (props) => {
  const [updateTime, setUpdateTime] = useState(0);
  const [switchStatus, setSwitchStatus] = useState({
    chips: new Array(props.numChips).fill(false),
  });

  const setSwitchOverride = (value) => {
    if (!switchStatus["override"]) {
      sendRequest("set_" + props.apiName + "_override");
    } else {
      sendRequest("clear_" + props.apiName + "_override");
    }
  };

  useEffect(() => {
    subscribeToEvent("gui_" + props.apiName, (err, data) => {
      setSwitchStatus(data);
      setUpdateTime(new Date());
    });
  }, []);

  useEffect(() => {
    if (props.ws !== null) {
      props.ws.addEventListener("message", function (event) {
        const json = JSON.parse(event.data);
        if (props.apiName in json) {
          //console.log(json[props.apiName]);
          setSwitchStatus(json[props.apiName]);
          setUpdateTime(new Date());
        }
      });
    }
  }, [props.ws]);

  return (
    <RiddleCard title={props.name} updateTime={updateTime}>
      <div>
        {Array.from({ length: props.numChips }, (item, index) => (
          <Chip>
            {props.chipNames
              ? props.chipNames[index] + " : " + switchStatus.chips[index]
              : index + " : " + switchStatus.chips[index]}
          </Chip>
        ))}
      </div>
    </RiddleCard>
  );
};

export default MiscCard;
